import { StreakFreezeInfo, StreakDay } from '../api/api';

// A freeze is available (unused) this quarter iff the user is eligible and no freeze has been applied
// yet. Availability is derived from `usedDate == null` since the BE contract (BRAINTECH-5854) grants
// exactly 1 freeze per quarter with no carry-over.
export function isFreezeAvailable(freeze: StreakFreezeInfo): boolean {
  return freeze.eligible && freeze.usedDate == null;
}

// BEM modifier for a day cell in the weekly streak strip (shared by StreakModal and
// StreakProtectedModal so the frozen/active/inactive precedence stays in one place).
export function dayVariant(day: Pick<StreakDay, 'count' | 'frozen'>): 'frozen' | 'active' | 'inactive' {
  if (day.frozen) {
    return 'frozen';
  }
  return day.count > 0 ? 'active' : 'inactive';
}
